import { render, staticRenderFns } from "./ContentItemDeliverAt.vue?vue&type=template&id=772e1bd9&"
import script from "./ContentItemDeliverAt.vue?vue&type=script&lang=ts&"
export * from "./ContentItemDeliverAt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports